import { Component, OnInit, ViewChild } from '@angular/core';
import { creFadeInOut } from 'cre-ng';
import { Carousel } from 'primeng/carousel';

import { AuthService } from '@app/core/auth.service';
import { User } from '@app/core/core.model';
import { WeeklyCompetitionDetails } from './wig-weekly-competition-details.model';
import { WigWeeklyCompetitionDetailsService } from './wig-weekly-competition-details.service';

@Component({
  animations: [creFadeInOut],
  selector: 'app-wig-weekly-competition-details',
  styleUrls: ['./wig-weekly-competition-details.component.css'],
  templateUrl: './wig-weekly-competition-details.component.html',
})
export class WigWeeklyCompetitionDetailsComponent implements OnInit {
  currentWeekDates: Date[] = [];
  currentWeekIndex: number;
  defaultWeekIndex: number;
  isDataLoaded = false;
  weeklyCompetitionDetails: WeeklyCompetitionDetails[];

  @ViewChild('weeklyCompetitionDetailsCarousel') weeklyCompetitionDetailsCarousel: Carousel;

  private currentUser: User;
  private lastWeekIndex: number;

  constructor(
    private authService: AuthService,
    private wigWeeklyCompetitionDetailsService: WigWeeklyCompetitionDetailsService
  ) {}

  calculateWeekDates() {
    if (this.weeklyCompetitionDetails.length > 0) {
      this.currentWeekDates[0] = this.weeklyCompetitionDetails[this.currentWeekIndex].weekStartDate;
      for (let i = 0; i < 7; i++) {
        const newDate = new Date(this.currentWeekDates[0]);
        newDate.setDate(newDate.getDate() + i);
        this.currentWeekDates[i] = newDate;
      }
    }
  }

  convertMacroResults(macroResponse: string) {
    if (macroResponse === 'Y') {
      return 'Yes';
    } else if (macroResponse === 'N') {
      return 'No';
    } else if (macroResponse === '-') {
      return 'No response';
    } else {
      return 'No driving - no response required';
    }
  }

  nextWeek() {
    if (this.currentWeekIndex < this.lastWeekIndex) {
      this.currentWeekIndex++;
      this.weeklyCompetitionDetailsCarousel.navForward(this, this.currentWeekIndex);
      this.calculateWeekDates();
    }
  }

  ngOnInit() {
    this.currentUser = this.authService.getCurrentUser();
    this.defaultWeekIndex = -1;

    this.wigWeeklyCompetitionDetailsService
      .getWeeklyCompetitionDetails(this.currentUser.username)
      .then((data) => {
        this.weeklyCompetitionDetails = data;
        this.lastWeekIndex = data.length - 1;
        this.isDataLoaded = data.length > 0;

        for (let i = 0; i < data.length; i++) {
          if (data[i].fleetMatchup.hasCompData) {
            this.defaultWeekIndex = i;
          }
        }
        if (this.defaultWeekIndex === -1) {
          this.defaultWeekIndex = this.lastWeekIndex;
        }
        this.currentWeekIndex = this.defaultWeekIndex;
        this.calculateWeekDates();
      });
  }

  previousWeek() {
    if (this.currentWeekIndex > 0) {
      this.currentWeekIndex--;
      this.weeklyCompetitionDetailsCarousel.navBackward(this, this.currentWeekIndex);
      this.calculateWeekDates();
    }
  }
}
